import { SUMMARY_HEADERS } from "@/utils/enums/graphql";

export const CALCULATE_BY_ALL = [
  SUMMARY_HEADERS.REVENUES,
  SUMMARY_HEADERS.TRANSACTIONS,
];
